const PRIORITY_KEYS = ["errors", "message", "detail", "title"];
// ProblemDetails metadata that must never be shown as a message
const SKIP_KEYS = new Set(["type", "traceId", "status"]);

export function extractErrorMessage(error) {
  const fallback = "حدث خطأ أثناء تنفيذ الطلب";

  try {
    const data =
      (error && error.response && error.response.data) ||
      (error && error.data) ||
      error;

    const seen = new Set();

    function findMessage(val, depth = 0) {
      if (val == null) return null;
      if (depth > 4) return null; // avoid deep recursion

      if (typeof val === "string" && val.trim()) return val.trim();
      if (typeof val === "number") return String(val);

      if (typeof val === "object") {
        if (seen.has(val)) return null;
        seen.add(val);

        // Array of messages or nested arrays/objects
        if (Array.isArray(val)) {
          for (const item of val) {
            const msg = findMessage(item, depth + 1);
            if (msg) return msg;
          }
          return null;
        }

        // Priority fields: validation errors ({ field: ["msg"] }), then
        // Axios-style { message }, then ProblemDetails detail/title
        for (const k of PRIORITY_KEYS) {
          const msg = findMessage(val[k], depth + 1);
          if (msg) return msg;
        }

        // Object fields: pick the first usable message
        const keys = Object.keys(val);
        for (const k of keys) {
          if (SKIP_KEYS.has(k)) continue;
          const v = val[k];
          // Common validation shape: { field: ["message", ...] }
          if (Array.isArray(v)) {
            for (const item of v) {
              const msg = findMessage(item, depth + 1);
              if (msg) return msg;
            }
            continue;
          }
          const msg = findMessage(v, depth + 1);
          if (msg) return msg;
        }
      }

      return null;
    }

    return findMessage(data) || fallback;
  } catch (e) {
    return fallback;
  }
}